import { createI18n } from 'vue-i18n';
import en from './en.json';
import ar from './ar.json';

const STORAGE_KEY = 'meed.locale';

export function getInitialLocale() {
  if (typeof window === 'undefined') return 'ar';
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === 'en' || saved === 'ar') return saved;
  const browser = (navigator.language || 'ar').toLowerCase();
  return browser.startsWith('ar') ? 'ar' : 'en';
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages: { en, ar }
});

export function applyDocumentLocale(locale) {
  if (typeof document === 'undefined') return;
  const dir = locale === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('lang', locale);
  document.documentElement.setAttribute('dir', dir);
}

export function setLocale(locale) {
  if (locale !== 'ar' && locale !== 'en') return;
  i18n.global.locale.value = locale;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, locale);
  }
  applyDocumentLocale(locale);
}

applyDocumentLocale(i18n.global.locale.value);
